import React from 'react';
import { FadeIn } from './FadeIn';
import { Lock, Zap } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferCta() {
  return <section id="offer" className="py-10 md:py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-130">
      <FadeIn data-id="element-131">
        <div className="bg-gradient-to-b from-slate-800 to-slate-900 border border-slate-700 rounded-3xl p-8 md:p-12 lg:p-16 text-center shadow-2xl relative overflow-hidden" data-id="element-132">
          {/* Decorative elements */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-133">
            <div className="absolute -top-24 -right-24 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl" data-id="element-134"></div>
            <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl" data-id="element-135"></div>
          </div>

          <div className="relative z-10" data-id="element-136">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-137">
              Recupera el mando de tu día hoy mismo.
            </h2>

            <p className="text-xl md:text-2xl text-slate-300 mb-12 max-w-2xl mx-auto" data-id="element-138">
              Accede a{' '}
              <span className="text-white font-medium italic" data-id="element-139">
                "La Parálisis del Todo o Nada"
              </span>{' '}
              y detén el ciclo de culpa y agotamiento.
            </p>

            <div className="mb-10" data-id="element-140">
              <div className="inline-block bg-red-500/20 text-red-400 font-bold text-sm uppercase tracking-widest px-4 py-1.5 rounded-full mb-4 border border-red-500/30" data-id="element-141">
                🔥 Solo por hoy — 62% de descuento
              </div>
              <p className="text-slate-400 uppercase tracking-widest text-sm font-bold mb-3" data-id="element-142">
                Inversión única
              </p>
              <div className="flex items-center justify-center gap-4" data-id="element-143">
                <span className="text-2xl md:text-3xl text-slate-500 line-through font-heading font-bold" data-id="element-144">
                  $17
                </span>
                <div className="text-6xl md:text-7xl font-heading font-bold text-amber-500 flex items-start" data-id="element-145">
                  <span className="text-3xl md:text-4xl mt-2 mr-1" data-id="element-146">$</span>
                  6,39
                </div>
              </div>
            </div>

            <a href="https://www.nachogerberg.com/cart/42710783787079:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="w-full sm:w-auto bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold text-lg md:text-xl py-5 px-8 md:px-12 rounded-full transition-all duration-300 transform hover:scale-105 shadow-[0_0_30px_rgba(245,158,11,0.3)] flex items-center justify-center gap-3 mx-auto mb-6 group inline-flex" data-id="element-147">
              <Zap className="w-6 h-6 group-hover:animate-pulse" data-id="element-148" />
              QUIERO SALIR DE LA PARÁLISIS AHORA
            </a>

            <div className="flex items-center justify-center gap-2 text-slate-400 text-sm md:text-base" data-id="element-149">
              <Lock className="w-4 h-4" data-id="element-150" />
              <p data-id="element-151">
                Acceso inmediato tras la compra. Empieza a leer (y a hacer) en 2
                minutos.
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}